function o(t, e, i) {
  const r = t.getAttribute(e);
  let n = r ? r.split(/\s+/) : [];
  n = n.filter((s) => !i.find((u) => s === u)), n.length ? t.setAttribute(e, n.join(" ")) : t.removeAttribute(e);
}
function A(t, e, i) {
  const r = Array.isArray(i) ? i : [i], n = t.getAttribute(e), s = n ? n.split(/\s+/) : [];
  return r.every((u) => s.indexOf(u) > -1) ? () => {
  } : (s.push(...r), t.setAttribute(e, s.join(" ")), () => o(t, e, r));
}
export {
  o as a,
  A as c
};
//# sourceMappingURL=condition-attribute-with-id-DpTOoDfo.js.map
